<template>
  <v-container id="Auditoria" fluid>
    <v-row>
      <v-col col="12" class="text-center mb-8">
        <h2 class="font-heading text-h3 mb-4">
          Gestion de Negocios
        </h2>
        <v-divider class="mx-auto bg-brand-orange" style="max-width: 100px; height: 4px;"></v-divider>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="6">
        <v-img
          src="https://blog.omnitok.chat/wp-content/uploads/2023/01/iStock-1369953931-1024x576.jpg"
          alt="Gestion"
          class="rounded-lg"
          cover
          height="400"
        ></v-img>
      </v-col>
      <v-col cols="12" md="6">
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Este servicio comprende tanto a nuevos negocios como negocios en marcha. Se utilizan una serie de herramientas
          que permiten analizar el negocio en todas sus areas y con esta información definir la VISION y las ESTRATEGIAS,
          proceder a su implementación mediante un plan de acción y controlar su correcta ejecución
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Se analiza e investiga la situación actual de la empresa, su historia y antecedentes, el mercado y segmentos
          en los que opera, el lugar que ocupa en el mercado, su potencial y proyección, sus recursos y toda información
          que permita conocer e identificar a la empresa y sus integrantes.
        </p>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="10" offset-md="1">
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Abarca los siguientes aspectos:
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6"><strong>ESTRATEGIA:</strong>
          Las estrategias nos dicen como llegar a cumplir la Misión, Visión y Objetivos de la empresa. Todo negocio
          debe empezar con una visión, una meta y objetivos. Sin una estrategia eficaz, es poco probable que estos
          sueños se hagan realidad.
        </p>
        <v-card class="mx-auto text-white mb-8" color="orange">
          <v-card-text class="text-h5 text-justify py-2">
            "Si no sabemos a que puerto nos dirigimos, ningún viento es favorable"
          </v-card-text>

          <v-card-actions class="mt-auto d-flex justify-end">
            <span>Séneca</span>
          </v-card-actions>
        </v-card>
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Definir la estrategia del negocio es vital para su subsistencia y desarrollo. Nuestro servicio comprende
          la aplicación de las siguientes estrategias de negocios:
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6"><strong>Estrategia de Integración:</strong>
          Según las capacidades y recursos de la empresa, permiten ganar control sobre la cadena de valor.
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6"><strong>Estrategias Intensivas:</strong>
          Comprenden el desarrollo de nuevos productos y mercados, la penetración en el mercado y la diversificación.
          Estas se utilizan para mejorar la posición competitiva.
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6"><strong>Estrategias Defensivas:</strong>
          Utilizadas en mercados saturados o cuando la empresa tuvo un crecimiento excesivo. Comprende la reducción de
          costos y activos para revertir la relación activos/beneficios. También la desinversión por medio de venta de
          parte de la empresa.
        </p>
        <p class="text-body-1 text-grey-darken-2 mb-6">
          Datos que sorprenden:
        </p>
        <v-list
          class="bg-transparent pa-0 elevation-0"
          :items="items"
          item-title="title"
          item-icon="icon"
        ></v-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      items: [
        {
          title: 'El 80% de las Pymes no tiene estrategia',
          value: 1,
          icon: 'mdi-arrow-right-box'
        },
        {
          title: 'Solo el 25% de los gerentes tienen incentivos vinculados a la estrategia',
          value: 2,
          icon: 'mdi-arrow-right-box'
        },
        {
          title: 'Solo el 5% de los empleados conoce la estrategia',
          value: 3,
          icon: 'mdi-arrow-right-box'
        },
        {
          title: 'El 85% de los empresarios dedica menos de una hora al mes a revisar las estrategias',
          value: 4,
          icon: 'mdi-arrow-right-box'
        },
      ],
    }
  }
}
</script>
<style lang="">
    
</style>